import { type TFunction } from 'i18next';

import { UserAccessRole } from './types';

export const getRolesList = (t: TFunction) => [
  { label: t('layouts.organizations.create.rbac.admin'), value: UserAccessRole.ADMIN },
  { label: t('layouts.organizations.create.rbac.basic'), value: UserAccessRole.BASIC }
];
